import { intlShape, FormattedMessage } from 'react-intl';
import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';
import clamp from 'text-overflow-clamp';

import { WixConnect } from 'widget/player-widget/utils/wix-connect';
import resizeImage from 'widget/player-widget/utils/resize-image';

import { pickContextTypes } from '../../context-types';

import ScrollbarWrapper from 'widget/player-widget/components/scrollbar-wrapper/scrollbar-wrapper';

import styles from './info.styl';

import translations from './translations';
import crewTranslations from 'shared/translations/crew';
import genreTranslations from 'shared/translations/genres';


const POSTER_SIZE = {
  width: 303,
  height: 449,
};

const POSTER_SIZE_FULLSCREEN = {
  width: 450,
  height: 667,
};


@WixConnect(styles)
export default class InfoOverlayInfo extends React.Component {

  static propTypes = {
    appSettings: React.PropTypes.object,
    intl: intlShape,
  };

  static contextTypes = pickContextTypes('videoItem', 'fullScreen');

  componentDidMount() {
    this.clamp();

    window.addEventListener('resize', this.setPosterSize);
    this.setPosterSize();
  }

  componentDidUpdate() {
    this.clamp();
    this.setPosterSize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setPosterSize);
  }

  clamp() {
    clamp(this.title, { lineClamp: 2 });
  }

  getRoles(rolesType) {
    const { videoItem: { [rolesType]: roles } } = this.context;
    const { intl: { formatMessage } } = this.props;

    if (!roles || !roles.length) {
      return null;
    }

    const roleElements = _.map(roles, function ({ role, name }, index) {
      if (rolesType === 'crew') {
        role = formatMessage(crewTranslations[role]);
      }

      return (
        <div key={index}
             styleName="role-item"
             className={`qa-overlay-info-${rolesType}`}>
          <div styleName="role">{role}</div>
          <div styleName="name">{name}</div>
        </div>
      );
    });

    return (
      <div styleName="roles-wrapper">
        <div styleName="roles-title">
          <FormattedMessage {...translations[rolesType]} />
        </div>

        {roleElements}
      </div>
    );
  }

  posterEl = null;

  @autobind
  savePosterRef(el) {
    this.posterEl = el;
  }

  @autobind
  setPosterSize() {
    const poster = this.posterEl;

    if (!poster) {
      return null;
    }

    const { fullScreen } = this.context;

    if (fullScreen) {
      const { width, height } = POSTER_SIZE_FULLSCREEN;
      poster.style.height = `${Math.floor(poster.offsetWidth / width * height)}px`;
    } else {
      const { width, height } = POSTER_SIZE;
      poster.style.width = `${Math.floor(poster.offsetHeight / height * width)}px`;
    }
  }

  getPosterImage(width, height) {
    const { videoItem: { posterUrl }, fullScreen } = this.context;
    const { hosts } = this.props.appSettings;

    if (!posterUrl) {
      return null;
    }

    const resizedPosterUrl = resizeImage(posterUrl, width * 2, height * 2);

    return (
      <div ref={this.savePosterRef}
           styleName={classnames('poster', { fullscreen: fullScreen })}
           className="qa-overlay-info-poster"
           style={{ backgroundImage: `url(${hosts.image}${resizedPosterUrl})` }} />
    );
  }

  get poster() {
    const { fullScreen } = this.context;

    if (fullScreen) {
      return null;
    }

    return this.getPosterImage(POSTER_SIZE.width, POSTER_SIZE.height);
  }

  get fullScreenPoster() {
    const { fullScreen } = this.context;

    if (!fullScreen) {
      return null;
    }

    return this.getPosterImage(POSTER_SIZE_FULLSCREEN.width, POSTER_SIZE_FULLSCREEN.height);
  }

  get publisher() {
    const { videoItem: { publisher } } = this.context;

    if (!publisher) {
      return null;
    }

    return (
      <div styleName="info-item"
           className="qa-overlay-info-publisher">
        <FormattedMessage {...translations.publisher}
                          values={{ author: publisher }} />
      </div>
    );
  }

  get genres() {
    const { videoItem: { genre } } = this.context;

    if (!genre) {
      return null;
    }

    return (
      <div styleName="info-item"
           className="qa-overlay-info-genres">
        <FormattedMessage {...genreTranslations[genre]} />
      </div>
    );
  }

  get duration() {
    const { videoItem: { durationStr } } = this.context;

    if (!durationStr) {
      return null;
    }

    return (
      <div styleName="info-item"
           className="qa-overlay-info-duration">
        {durationStr}
      </div>
    );
  }

  get description() {
    const { videoItem: { description } } = this.context;

    if (!description) {
      return null;
    }

    return (
      <div styleName="description"
           className="qa-overlay-info-description">
        {description}
      </div>
    );
  }

  render() {
    const { videoItem: { title }, fullScreen } = this.context;

    const styleNames = classnames('wrapper', {
      'full-screen': fullScreen,
    });

    return (
      <div styleName={styleNames}
           className="qa-player-overlay-info">
        {this.poster}

        <ScrollbarWrapper styleName="scrollbar-wrapper">
          <div styleName="main-info">
            <div ref={node => (this.title = node)}
                 styleName="title"
                 className="qa-overlay-info-title"
                 title={title}>
              {title}
            </div>

            <div styleName="info">
              {this.publisher}
              {this.genres}
              {this.duration}
            </div>

            {this.description}
            {this.fullScreenPoster}

            {this.getRoles('cast')}
            {this.getRoles('crew')}
          </div>
        </ScrollbarWrapper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/info-overlay/info/info.js